import React, { useState } from 'react';
import { Box, Collapse, Typography, IconButton, Divider, List, ListItem } from '@mui/material';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import CountBadge from '../../Common/CountBadge/CountBadge';

const Drawer = ({ scrollToSection, sections, relatedEntitiesCount }) => {
  const [open, setOpen] = useState(true);

  const handleToggle = () => {
    setOpen(!open);
  };

  return (
    <Box display="flex" alignItems="flex-start" sx={{
      marginTop: '1px'
    }}>
      <Divider />
      <Collapse in={open} orientation="horizontal" sx={{
        height: '100%',

      }}>
        <Box
          sx={{
            width: 240,
            backgroundColor: 'white',
            padding: 2,
            height: '100%',

          }}
        >
          {/* <Typography>Here are the details!</Typography> */}
          <List sx={{ position: 'sticky', top: 0 }}>
            <ListItem
              onClick={() => scrollToSection(sections.notesRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Notes <CountBadge count={relatedEntitiesCount?.notesCount} />
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.attachmentsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Attachments <CountBadge count={relatedEntitiesCount?.attachmentsCount} />
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.dealsRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Deals <CountBadge count={relatedEntitiesCount?.dealsCount} />
              </Typography>
            </ListItem>
            <ListItem
              onClick={() => scrollToSection(sections.openActivitiesRef)}
              sx={{ cursor: 'pointer' }}
            >
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Open Activities <CountBadge count={relatedEntitiesCount?.openTasksCount} />
              </Typography>
            </ListItem>
            <ListItem 
            onClick={() => scrollToSection(sections.closedActivitiesRef)}
            sx={{ cursor: 'pointer' }}>
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Closed Activities <CountBadge count={relatedEntitiesCount?.closedTasksCount} />
              </Typography>
            </ListItem>
            <ListItem 
            onClick={() => scrollToSection(sections.campaignsRef)}
            sx={{ cursor: 'pointer' }}>
              <Typography
                sx={{
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Campaigns <CountBadge count={relatedEntitiesCount?.campaignsCount} />
              </Typography>
            </ListItem>
          </List>


        </Box>
      </Collapse>
      <IconButton onClick={handleToggle} sx={{ position: 'sticky', top: 0 }}>
        {open ? <ChevronLeft /> : <ChevronRight />}
      </IconButton>
    </Box>
  );
};

export default Drawer;
